import React, { useCallback, useEffect, useState } from "react"
import withModal from "../../utils/hoc/withModal";
import InfluencerAccountStats from "../influencer/InfluencerAccountStats";
import { CollaborationPost } from "../../types/collaborations/CollaborationTypes";
import { formatNumber, toValidNumber } from "../../utils/helpers";
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination } from "swiper/modules";
import 'swiper/css';
import 'swiper/css/pagination';
import InfluencerCollaborationInsightSkeleton from "../../skeletons/InfluencerCollaborationInsightSkeleton";
import Badge from "../badges/Badge";
import { useDispatch } from "react-redux";
import { fetchCollaboration } from "../../redux-stores/slices/collaborationDetailsSlice";
import { AppDispatch, RootState } from "../../redux-stores/store";
import { useSelector } from "react-redux";

interface Insight {
    name: string;
    count: number
}

interface PostsCounts {
    [key: string]: Insight
}

interface PostsInsights {
    [key: string]: Insight
}

const InfluencerCollaborationInsights: React.FC<{ campaignId: string, onClose: () => void }> = ({ campaignId, onClose }) => {

    const dispatch:AppDispatch = useDispatch();

    const collaborationData = useSelector(
        (state: RootState) => state.collaborationDetails.collaborations[campaignId]?.collaborationData
    );

    const [totalPostsCount, setTotalPostsCount] = useState<number>(0);
    const [postsCounts, setPostsCounts] = useState<PostsCounts>({
        STORY: { name: "Story", count: 0 },
        FEED: { name: "Post", count: 0 },
        REELS: { name: "Reel", count: 0 },
    })

    const [posts, setPosts] = useState<CollaborationPost[]>([]);

    const [postInsights, setPostInsights] = useState<PostsInsights>({
        total_interactions: { name: "Interactions", count: 0 },
        reach: { name: "Accounts Reached", count: 0 },
        views: { name: "Views", count: 0 },
    })

    const fetchCollaborationData = useCallback(async () => {
        await dispatch(fetchCollaboration({campaignId}))
    },[dispatch, campaignId])

    const processPostsData = useCallback(() => {
        if (!collaborationData) return;

        const collaboration = collaborationData.collaboration;

        const collaborationPosts = collaboration.posts ?? [];

        const post_counts: PostsCounts = {
            STORY: { name: "Story", count: 0 },
            FEED: { name: "Post", count: 0 },
            REELS: { name: "Reel", count: 0 }
        };

        const post_insights: PostsInsights = {
            total_interactions: { name: "Interactions", count: collaboration.interactions_count ?? 0 },
            views: { name: "Views", count: collaboration.views_count ?? 0 }
        };

        for(let post of collaborationPosts){
            if(post.status !== 'approved') continue;
            post_counts[post.ig_post.media_product_type].count++
        }

        setTotalPostsCount(collaboration.approved_posts_count ?? 0);
        setPostInsights(post_insights);
        setPostsCounts(post_counts);
        setPosts(collaborationPosts);

    }, [collaborationData])

    useEffect(() => {
        if (campaignId) {
            fetchCollaborationData();
        }
    }, [campaignId, fetchCollaborationData])

    useEffect(() => {
        if (collaborationData) {
            processPostsData();
        }
    }, [collaborationData, processPostsData])


    if (!collaborationData)
        return (<InfluencerCollaborationInsightSkeleton onClose={onClose} />)

    return (
        <div>
            <div className="menu-title">
                {/* <div className="d-flex flex-row align-items-center m-2 mt-4">
                    <span>
                        <div className="symbol symbol-100px symbol-circle">
                            <img src={influencer?.account?.profile_picture_url} style={{ borderRadius: '50%' }} width={60} alt="profilepic" />
                        </div>
                    </span>
                    <div className="d-flex ps-3 flex-column">
                        <div className="d-flex align-items-center">
                            <h6 className="font-600 pt-1 mb-n1">{influencer?.name}</h6>
                        </div>
                        {
                            influencer?.gender_name &&
                            <span className="font-weight-bold d-flex align-items-center font-12 gap-2 mt-1">
                                {
                                    influencer?.gender_name === 'Male' &&
                                    <i className="fa-solid fa-mars"></i>
                                }
                                {
                                    influencer?.gender_name === 'Female' &&
                                    <i className="fa-solid fa-venus"></i>
                                }
                                <strong>{influencer?.gender_name}</strong>
                            </span>
                        }

                        {
                            influencer?.age &&
                            <span className="font-weight-bold d-flex align-items-center gap-2 font-12"><i className="fa-solid fa-cake-candles"></i> <strong>{influencer?.age}</strong></span>
                        }
                    </div>
                </div> */}
                <button className="close-menu mt-n5" onClick={e => onClose()}>
                    <i className="fa fa-times-circle"></i>
                </button>
            </div>
            <div className="content mt-2 pb-4">
                {/* {
                    influencer?.account &&
                    <InfluencerAccountStats account={influencer?.account} insightsPage />
                } */}
                <div className="card-body border-bottom py-2 d-flex flex-column">
                    <h6 className="mt-2">Overall Collaboration</h6>
                    <div className="d-flex flex-row mt-2"><span className="fw-bold">Total Content Posted</span><span className="fw-bold ms-auto">{totalPostsCount}</span></div>
                    {
                        Object.values(postsCounts).map((row, i) => {
                            return (
                                <div className="d-flex flex-row" key={i}><span>{row.name} Posted</span><span className="ms-auto">{row.count}</span></div>
                            )
                        })
                    }
                </div>
                {
                    posts.length > 0 &&
                    <React.Fragment>
                        <div className="card-body border-bottom py-2 d-flex flex-column">
                            <h6 className="mt-2">Social Performance</h6>
                            {/* <div className="d-flex flex-row mt-2"><span className="fw-bold">Total Content Posted</span><span className="fw-bold ms-auto">{totalPostsCount}</span></div> */}
                            {
                                Object.values(postInsights).map((row, i) => {
                                    return (
                                        <div className="d-flex flex-row" key={i}><span>Total {row.name}</span><span className="ms-auto">{row.count}</span></div>
                                    )
                                })
                            }
                        </div>
                        <Swiper pagination={true} modules={[Pagination]} className="mySwiper mt-2">
                            {
                                posts.map((post, i) => {
                                    return (
                                        <SwiperSlide key={i}>
                                            <div className="card-body d-flex mt-2 flex-row align-items-center">
                                                <div className="">
                                                    <span className="cursor-pointer d-block rounded-4 mb-3" style={{
                                                        backgroundImage: `url(${post.ig_post.thumbnail_url})`,
                                                        position: 'relative',
                                                        backgroundColor:'#000',
                                                        backgroundPosition: '50%',
                                                        backgroundRepeat: 'no-repeat',
                                                        backgroundSize: 'contain',
                                                        width: '100px',
                                                        paddingBottom: '50%'
                                                    }}></span>
                                                </div>
                                                <div className="d-flex flex-fill flex-column justify-content-between ms-3 mb-3">
                                                    <div className="d-flex justify-content-start m-2 ms-0">
                                                        {
                                                            post.status === 'approved' &&
                                                            <Badge variant='success'><i className="fa fa-check me-1"></i>Approved</Badge>
                                                        }
                                                        {
                                                            post.status === 'rejected' &&
                                                            <Badge variant="danger"><i className="fa fa-times me-1"></i> Declined</Badge>

                                                        }
                                                        {
                                                            post.status === 'pending' &&
                                                            <Badge variant="warning"><i className="fas fa-clock me-1"></i> Pending Approval</Badge>

                                                        }
                                                    </div>
                                                    {
                                                        post.ig_post.caption &&
                                                        <p className="text-start" style={{ whiteSpace: "pre-wrap" }}>{post.ig_post.caption}</p>
                                                    }
                                                    <div className="d-flex justify-content-between">
                                                        <span><i className="fa-solid fa-heart"></i> {formatNumber(toValidNumber(post.ig_post.like_count))}</span>
                                                        <span><i className="fa-solid fa-comment"></i>  {formatNumber(toValidNumber(post.ig_post.comments_count))}</span>
                                                        <span><i className="fa-solid fa-eye"></i> {formatNumber(toValidNumber(post.ig_post.views_count))}</span>
                                                        <span><i className="fa-solid fa-share-nodes"></i>  {formatNumber(toValidNumber(post.ig_post.shares_count))}</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </SwiperSlide>
                                    )
                                })
                            }
                        </Swiper>
                    </React.Fragment>
                }
                {
                    posts.length === 0 && <span className="w-100 d-flex justify-content-center p-4">No Content Posted</span>
                }
            </div>
        </div>
    )
}

export default withModal(InfluencerCollaborationInsights)